import { useEffect, useRef } from 'react';

function useUpdateEffect(effect, dependencies) {
  const didMount = useRef(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => effect(didMount.current), dependencies);

  useEffect(() => {
    didMount.current = true;
  }, []);
}

export default useUpdateEffect;
